var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 12C3.44444 12 2.97222 11.8056 2.58333 11.4167C2.19444 11.0278 2 10.5556 2 10C2 9.44444 2.19444 8.97222 2.58333 8.58333C2.97222 8.19444 3.44444 8 4 8V6.5C4 6.0875 4.14687 5.73438 4.44062 5.44063C4.73437 5.14688 5.0875 5 5.5 5H8C8 4.44444 8.19444 3.97222 8.58333 3.58333C8.97222 3.19444 9.44444 3 10 3C10.5556 3 11.0278 3.19444 11.4167 3.58333C11.8056 3.97222 12 4.44444 12 5H14.5C14.9125 5 15.2656 5.14688 15.5594 5.44063C15.8531 5.73438 16 6.0875 16 6.5V8C16.5556 8 17.0278 8.19444 17.4167 8.58333C17.8056 8.97222 18 9.44444 18 10C18 10.5556 17.8056 11.0278 17.4167 11.4167C17.0278 11.8056 16.5556 12 16 12V15.5C16 15.9125 15.8531 16.2656 15.5592 16.5594C15.2653 16.8531 14.9119 17 14.4992 17H5.49417C5.08139 17 4.72917 16.8531 4.4375 16.5594C4.14583 16.2656 4 15.9125 4 15.5V12ZM8.20833 10.2083C8.40278 10.0139 8.5 9.77778 8.5 9.5C8.5 9.22222 8.40278 8.98611 8.20833 8.79167C8.01389 8.59722 7.77778 8.5 7.5 8.5C7.22222 8.5 6.98611 8.59722 6.79167 8.79167C6.59722 8.98611 6.5 9.22222 6.5 9.5C6.5 9.77778 6.59722 10.0139 6.79167 10.2083C6.98611 10.4028 7.22222 10.5 7.5 10.5C7.77778 10.5 8.01389 10.4028 8.20833 10.2083ZM12.9583 10.2083C13.1528 10.0139 13.25 9.77778 13.25 9.5C13.25 9.22222 13.1528 8.98611 12.9583 8.79167C12.7639 8.59722 12.5278 8.5 12.25 8.5C11.9722 8.5 11.7361 8.59722 11.5417 8.79167C11.3472 8.98611 11.25 9.22222 11.25 9.5C11.25 9.77778 11.3472 10.0139 11.5417 10.2083C11.7361 10.4028 11.9722 10.5 12.25 10.5C12.5278 10.5 12.7639 10.4028 12.9583 10.2083ZM7 13.5H13V12H7V13.5ZM5.5 15.5H14.5V6.5H5.5V15.5Z",
    fill: "#6A0840"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile12);
export default __webpack_public_path__ + "static/media/profile-12.e5614f93ea0467acdf7bd7e838c7d418.svg";
export { ForwardRef as ReactComponent };